import React, { useState, useEffect } from 'react';
import SchemesPage from './SchemesRejPage';
import { getApmcByDepartmentId, getExistedSchemesAplication, submitApmcFiles } from '../../../../../auth/services/privateapicalling';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { toast } from 'react-toastify';

interface SchemesQueryProps {
  unverifiedFields?: string[];
  userRole?: string;
  existData?: any;
  
   
  resubmittedFields:any;
setResubmittedFields: React.Dispatch<React.SetStateAction<{
    annexureOne: any,
    annexureTwo: any,
    annexureThree: any
  }>>;
  validationErrors?: {[key: string]: string}; // Add this
  isValidating?: boolean; // Add this
  clearValidationError?: (errorKey: string) => void;
}

const SchemesQuery: React.FC<SchemesQueryProps> = ({ 
  unverifiedFields = [], 
  clearValidationError,
  userRole = '',
  existData: propExistData = null,
  
  resubmittedFields,
  setResubmittedFields,
  validationErrors = {}, // Add this with default value
  isValidating = false,
}) => {
  const token = useSelector((state:any)=>state.auth.token);
  const userDetail = useSelector((state:any)=>state.auth.userDetails)
  const location = useLocation()
  const applicationId = location.state?.applicationId;
  const id = location.state?.id;
  const [step, setStep] = useState<number>(1);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [editFieldValues, setEditFieldValues] = useState<{ [key: string]: any }>({});
  const [editFiles, setEditFiles] = useState<{ [key: string]: File | null }>({});
  const [editComment, setEditComment] = useState<string>("");
  const [apmcOptions, setApmcOptions] = useState<any>([]);
  const [districtOptions, setDistrictOptions] = useState<any>([]);
  const [talukaOptions, setTalukaOptions] = useState<any>([]);
  const [existData, setExistData] = useState<any | null>(propExistData);
  const [uploadLoading, setUploadLoading] = useState(false)
  
  const [formData, setFormData] = useState({
    district: existData?.annexureOne?.apmc?.data?.find((item: any) => item.fieldName === "District")?.value || "",
    apmcName: existData?.annexureOne?.apmc?.data?.find((item: any) => item.fieldName === "apmcName")?.value || "",
    taluka: existData?.annexureOne?.apmc?.data?.find((item: any) => item.fieldName === "Taluka")?.value || "",
    copyOfMarketCommitteEstDet: existData?.annexureOne?.copyOfMarketCommitteEstDet?.data ? existData?.annexureOne?.copyOfMarketCommitteEstDet?.data[0] : null as any,
    certOfMarketCommitteCategory: existData?.annexureOne?.certOfMarketCommitteCategory?.data ? existData?.annexureOne?.certOfMarketCommitteCategory?.data[0] : null as any,
    scheme: existData?.annexureOne?.purposeOfAssistance?.data?.scheme ? existData?.annexureOne?.purposeOfAssistance?.data?.scheme : "",
    purpose: existData?.annexureOne?.purposeOfAssistance?.data?.purpose ? existData?.annexureOne?.purposeOfAssistance?.data?.purpose : "",
    planProjectCost: existData?.annexureOne?.estimateProjectCost?.data[1] ? existData?.annexureOne?.estimateProjectCost?.data[1] : null as any,
    planEstimateProjectCost: existData?.annexureOne?.estimateProjectCost?.data[0] ? existData?.annexureOne?.estimateProjectCost?.data[0] : null as any,
    percentOfProjCostEligible: existData?.annexureOne?.percentOfProjCostEligible?.data ? existData?.annexureOne?.percentOfProjCostEligible?.data : "",
    planEstimateByApprovedPE: existData?.annexureOne?.planEstimateByApprovedPE?.data ? existData?.annexureOne?.planEstimateByApprovedPE?.data[0] : null as any,
    isExistingConstructionOnProjSite: existData?.annexureOne?.isExistingConstructionOnProjSite?.data ? existData?.annexureOne?.isExistingConstructionOnProjSite?.data : "",
    toolsEquipQuotations: existData?.annexureOne?.toolsEquipQuotations?.data ? existData?.annexureOne?.toolsEquipQuotations?.data[0] : null as any,
    estimateCertifiedByGovtEngineer: existData?.annexureOne?.estimateCertifiedByGovtEngineer?.data ? existData?.annexureOne?.estimateCertifiedByGovtEngineer?.data[0] : null as any,

    // APMCp2 file fields
    permissionFromAuthority: null as any,
    insuranceUndertakingPostConstruction: null as any,
    auditUndertakingAfterAssistance: null as any,
    schemeConditionsUndertaking: null as any,
    jointAccountAssistanceUndertaking: null as any,
    noPriorAssistanceUndertaking: null as any,
    registerMaintenanceUndertaking: null as any,
    repaymentOnViolationUndertaking: null as any,
    constructionCompletionCertificate: null as any,
    noOutstandingDuesUndertaking: null as any,
    constructionProcurementETendering: null as any,
    goodsProcurementETendering: null as any,
    
    // APMCp3 file fields
    isLandOwnedByMarketingCommitee: null as any,
    hasAssistanceApproved: "",
    assistanceDetails: [
      {
        dateField: "",
        scheme2: "",
        purpose2: "",
        sanctionedAmount: ""
      }
    ],
    
    isMarktingCommitteeLocatedInGeneral: "",
    marktingCommitteeLocatedInGeneral: null as any,
    isMarktingCommFinanciallyCapableOfExpense: "",
    marktingCommFinanciallyCapableOfExpense: null as any,
    incExpenditureForLast3Yrs: null as any,
    auditIncExpenditureForLast3Yrs: null as any,
    existingFarmerFacilities: null as any,
    marketCessIncome5YrsLast: null as any,
    marketCessIncome5YrsNext: null as any,
  });
   
  const [updatedFields, setUpdatedFields] = useState({});

  // DROPDOWN OF 12no.
const [assistanceDetails, setAssistanceDetails] = useState([
  {
    dateField: "",
    scheme2: "",
    purpose2: "",
    sanctionedAmount: "",
    assistanceReceived: "",
    totalExpenditure: "",
    shortfall: "",
    workCompletionDetails:"",
    contributionRatio: "",
  }
]);

 
  
  const getExistedApplication = async () => {
    // Only call API if existData is not already provided from parent
    if (propExistData) {
      setExistData(propExistData);
      
      return;
    }

    try {
   
      const response = await getExistedSchemesAplication(token, applicationId, id);
    
      if (response?.success) {
     
        setExistData(response?.data);
      }
    } catch (error) {
   
    }
  }

  // File handling functions remain the same...
// In SchemesQuery.tsx
const handleFileChange = (
  e: React.ChangeEvent<HTMLInputElement>, 
  fieldName: string, 
  documentName?: string
) => {
 
  const { name, files } = e.target;
  
  if (files && files.length > 0) {
    const file = files[0];
    const docName = documentName || name;
    
    let docId: any = null;
    
    // Look for existing docId in transaction data
    const userData = existData?.annexureOne?.[fieldName]?.transaction?.find(
      data => data.transactionBy === userDetail.Role.Role_Identifier
    );
    
    if (userData && userData.newValue) {
      const docData = userData.newValue.find(data => data?.fieldName === docName);
      docId = docData?.fieldValue || null;
    }
    
    handleUpload(docName, file, fieldName, docId);
  }
};

const handleUpload = async (
  documentName: string, 
  file: any, 
  fieldName: string, 
  docId?: string | null
) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("documentName", documentName);
  formData.append("fieldName", fieldName);
  formData.append("applicationId", applicationId);
  formData.append("schemeId", id);

  try {
    setUploadLoading(true);
    const res = await submitApmcFiles(formData, token, docId);

    
    // Check if response has success property
    if (res && res.success === false) {
    
      toast.error(`File upload failed: ${res.message || 'Unknown error'}`);
    }
    else if (res && res.success && res.docId) {
      // Store the updated field data
      setUpdatedFields(prev => ({
        ...prev,
        [documentName]: {
          docId: res.docId,
          documentName: documentName,
          fileName: file.name
        }
      }));
      
    
      toast.success("File uploaded successfully");
    }
    else {
     
      toast.error("File upload failed: Unexpected response format");
    }
  } catch (error) {
  
  } finally{
    setUploadLoading(false);

  }
};

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === "percentage") {
      let val = Number(value);
      if (val > 100) val = 100;
      if (val < 0) val = 0;
      setUpdatedFields(prev => ({
        ...prev,
        percentage: val === 0 && value === "" ? "" : String(val)
      }));
    } else {
      setUpdatedFields(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handlePreviewFile = (fileData: { base64: string, name: string, type: string }) => {
    if (fileData) {
      const fileWindow = window.open();
      if (fileWindow) {
        if (fileData.type.includes('pdf')) {
          fileWindow.document.write(
            `<iframe src="${fileData.base64}" width="100%" height="100%" style="border:none;"></iframe>`
          );
        } else {
          fileWindow.document.write(
            `<img src="${fileData.base64}" alt="${fileData.name}" style="max-width:100%;" />`
          );
        }
      }
    }
  };

  const handleEditChange = (name: string, value: any) => {
    setEditFieldValues(prev => ({ ...prev, [name]: value }));
  };

  const handleEditFileChange = (name: string, file: File | null) => {
    setEditFiles(prev => ({ ...prev, [name]: file }));
  };

  useEffect(() => {
    getExistedApplication();
  }, [propExistData]);
  useEffect(()=>{
       setAssistanceDetails(
       existData?.annexureThree?.hasAssistanceApproved?.data
         ? existData.annexureThree.hasAssistanceApproved.data
              .filter((item: any) => item.fieldName && item.fieldName.startsWith("details_"))
              .sort((a: any, b: any) => {
                const numA = parseInt(a.fieldName.split("_")[1], 10);
                const numB = parseInt(b.fieldName.split("_")[1], 10);
                return numA - numB;
              })
              .map((item: any) => ({
                dateField: item.value?.date || "",
                scheme2: item.value?.scheme || "",
                purpose2: item.value?.purpose || "",
                sanctionedAmount: item.value?.amount || "",
                assistanceReceived: item.value?.assistance || "",
                totalExpenditure: item.value?.expenditure || "",
                shortfall: item.value?.shortfall || "",
                workCompletionDetails: item.value?.completion || "",
                contributionRatio: item.value?.contribution || "",
              }))
            :  [
  {
    dateField: "",
    scheme2: "",
    purpose2: "",
    sanctionedAmount: "",
    assistanceReceived: "",
    totalExpenditure: "",
    shortfall: "",
    workCompletionDetails:"",
    contributionRatio: "",
  }
]
     );
  },[existData])

  return (
    <div className="">
      {/* Fixed Header + Stepper */}
      <div className=" start-0 end-0 z-3"
        style={{
        padding: "1rem",
        backgroundColor: "#f8f9fa",
      }}>
        <h2 className='ms-1'>
          Application for Scheme - પરિશિષ્ટ-બે (Annexure 2)
        </h2>
      </div>

      {/* Step Form Display */}
      <SchemesPage
        token={token}
        formData={formData}
        handleFileChange={handleFileChange}
        handleInputChange={handleInputChange}
        handlePreviewFile={handlePreviewFile}
        editingIndex={editingIndex}
        applicationId={applicationId}
        id={id}
        setEditingIndex={setEditingIndex}
        editFieldValues={editFieldValues}
       
        handleEditChange={handleEditChange}
        editFiles={editFiles}
        handleEditFileChange={handleEditFileChange}
        editComment={editComment}
        setEditComment={setEditComment}
        districtOptions={districtOptions}
        talukaOptions={talukaOptions}
        apmcOptions={apmcOptions}
        updatedFields={updatedFields}
        existData={existData}
        userDetail={userDetail}
        setUpdatedFields={setUpdatedFields}
        getExistedApplication={getExistedApplication}
        unverifiedFields={unverifiedFields}
        userRole={userRole}
        resubmittedFields={resubmittedFields}
        setResubmittedFields={setResubmittedFields}
         validationErrors={validationErrors} // Add this
        isValidating={isValidating}
        clearValidationError={clearValidationError}
         assistanceDetails={assistanceDetails}
      />
      {uploadLoading && (
        <div className="position-fixed z-3 top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ background: "rgba(0, 0, 0, 0.17)", zIndex: 1050 }}>
          <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Uploading...</span>
            </div>
            <div className="fw-bold">Uploading, please wait...</div>
          </div>
        </div>
      )}
    </div>
  );
};
 
export default SchemesQuery;
